import { msg } from "@lingui/core/macro";
import { logisticsApi } from "./apiClient";

export const activityCategoryDictionary = {
  HomeVisit: msg`Hembesök`,
  VideoCall: msg`Videosamtal`,
  ClinicVisit: msg`Mottagningsbesök`,
  PatientTask: msg`Patientaktivitet`,
  AdminTask: msg`Administrativ uppgift`,
  PatientMeasurementTask: msg`Mätvärden`,
};

export const finishActivityOccurrence = async (
  activityId: string,
  occurrenceId: string,
) => {
  await logisticsApi.post(
    `activities/${activityId}/occurrences/${occurrenceId}/finish`,
  );
};
